// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--dropdown[data-v-a0729b68]{border-bottom:none}.cv-header.bx--header[data-v-a0729b68]{z-index:1;background-color:#fff;height:53px;border:none}.cv-header-name.bx--header__name[data-v-a0729b68]{font-weight:400;font-size:14px;padding:0}", ""]);
// Exports
module.exports = exports;
